import useBreakpoint from '@/hooks/useBreakpoint';
import { forwardRef, useEffect, useRef, useState } from 'react';

export default function BackgroundGoogleAds() {
  const [isMobile] = useBreakpoint('tablet');
  const [isLoading, setIsLoading] = useState(true);
  const desktopBackgroundRef = useRef<HTMLDivElement>(null);
  const mobileBackgroundRef = useRef<HTMLDivElement>(null);

  // Log de debug para modo de operação
  useEffect(() => {
    if (isLoading && isMobile != null) setIsLoading(false);
  }, [isMobile]);

  return isMobile ? <MobileTopAds ref={mobileBackgroundRef} /> : <DesktopBackgroundAds ref={desktopBackgroundRef} />;
}

const MobileTopAds = forwardRef<HTMLDivElement>(function MobileTopAds(_, ref) {
  return (
    <div className="absolute bottom-0 left-0 top-[60px] flex h-[100px] w-full items-center justify-center has-[iframe[width='2000']]:fixed has-[iframe[width='2000']]:items-start tablet:left-[60px] tablet:top-0 tablet:w-[calc(100%_-_60px)] [&>span]:has-[iframe]:hidden [&_iframe[width='2000']]:absolute [&_iframe]:relative [&_iframe]:w-full">
      <div ref={ref} className="bg-ad active relative flex items-start justify-center" id={`div-gpt-ad-background/topo-mobile`} data-ad="true" />
    </div>
  );
});

const DesktopBackgroundAds = forwardRef<HTMLDivElement>(function DesktopBackgroundAds(_, ref) {
  return (
    <div className="absolute left-0 top-0 flex h-[250px] w-full items-center justify-center has-[iframe[width='2000']]:fixed has-[iframe[width='2000']]:h-screen tablet:left-[60px] tablet:w-[calc(100%_-_60px)] [&_iframe[width='2000']]:absolute [&_iframe[width='2000']]:h-full [&_iframe[width='2000']]:w-full [&_iframe]:relative [&_iframe]:left-0 [&_iframe]:top-0">
      <div ref={ref} className="bg-ad active" id={`div-gpt-ad-background/bg-topo-desktop`} data-ad="true" />
    </div>
  );
});
